/**
 * Shared patient information leaflets across all Pharmacy First pathways.
 * Update URLs here when leaflet links change - changes apply to all pathways automatically.
 */

export const sharedLeaflets = {
  // UTI Leaflets
  "leaflet-uti-en": {
    id: "leaflet-uti-en",
    title: "TARGET UTI Leaflet",
    description: "Patient information leaflet — English",
    url: "https://elearning.rcgp.org.uk/pluginfile.php/172227/mod_book/chapter/441/Common_Infection%20Materials%20TYI%20-%20UTI%2009.pdf",
    language: "en",
  },
  "leaflet-uti-cy": {
    id: "leaflet-uti-cy",
    title: "TARGET UTI Leaflet (Welsh Language)",
    description: "Patient information leaflet — Welsh (Cymraeg)",
    url: "https://elearning.rcgp.org.uk/pluginfile.php/172227/mod_book/chapter/441/UTI%20leaflet-%20women%20under%2065%20%28Welsh%29.pdf",
    language: "cy",
  },
  "leaflet-uti-other-languages": {
    id: "leaflet-uti-other-languages",
    title: "TARGET UTI Leaflet (Other languages)",
    description: "Patient information leaflet — Other languages",
    url: "https://elearning.rcgp.org.uk/mod/book/view.php?id=12647&chapterid=441",
    language: "other",
  },

  // Sore Throat / RTI Leaflets (also used for Sinusitis)
  "leaflet-sorethroat-en": {
    id: "leaflet-sorethroat-en",
    title: "TARGET Sore Throat Leaflet",
    description: "Patient information leaflet — English",
    url: "https://elearning.rcgp.org.uk/pluginfile.php/179949/mod_book/chapter/787/TYI-RTI%20Pharm%20Leaflet%20v9.8%20UKHSA.pdf?time=1662378551771",
    language: "en",
  },
  "leaflet-sorethroat-cy": {
    id: "leaflet-sorethroat-cy",
    title: "TARGET Sore Throat Leaflet (Welsh Language)",
    description: "Patient information leaflet — Welsh (Cymraeg)",
    url: "https://elearning.rcgp.org.uk/pluginfile.php/179949/mod_book/chapter/787/TI-RTI%20Pharm%20Leaflet%20v9.8%20Welsh%20-%20for%20those%20in%20England.pdf",
    language: "cy",
  },

  // Child's Cough Leaflet
  "leaflet-cough-en": {
    id: "leaflet-cough-en",
    title: "Children's Cough Leaflet",
    description: "Patient information leaflet — English",
    url: "https://child-cough.bristol.ac.uk/files/2016/01/UoB_Childrens-cough_PDF-leaflet_A4.pdf",
    language: "en",
  },

  // Impetigo Leaflet
  "leaflet-impetigo-en": {
    id: "leaflet-impetigo-en",
    title: "TARGET Impetigo Leaflet",
    description: "Patient information leaflet — English",
    url: "https://cdn.bad.org.uk/uploads/2021/12/15151840/Impetigo-PIL-Nov-2024.pdf",
    language: "en",
  },

  // Shingles Leaflet
  "leaflet-shingles-en": {
    id: "leaflet-shingles-en",
    title: "TARGET Shingles Leaflet",
    description: "Patient information leaflet — English",
    url: "https://cdn.bad.org.uk/uploads/2021/12/09094954/Shingles-PIL-Sept-2025.pdf",
    language: "en",
  },

  // Otitis Media Leaflet
  "leaflet-otitis-media-en": {
    id: "leaflet-otitis-media-en",
    title: "NICE Ear Infection (Otitis Media) Visual Summary",
    description: "Patient information leaflet — English",
    url: "https://www.nice.org.uk/guidance/ng91/resources/visual-summary-pdf-4787282702",
    language: "en",
  },
};
